module.exports = __webpack_public_path__ + "img/Roles.08c566f4.svg";